/**
 * Leaderboards Administration Page
 * Wraps the existing Admin Leaderboards component in SubscriptionLayout
 */

import React from 'react';
import SubscriptionLayout from '../../components/subscription/SubscriptionLayout';
import AdminLeaderboards from '../../admin/Leaderboards';

const LeaderboardsPage: React.FC = () => {
  return (
    <SubscriptionLayout>
      <AdminLeaderboards />
    </SubscriptionLayout>
  );
};

export default LeaderboardsPage;


